export default __webpack_public_path__ + "static/media/Award_Statue_LizardDoggo.256.a7eb53f8.png";